<template>
  <Drawer class="relatedProductsDrawer_box" :title="$t('key1005584')" width="1000" v-model="relatedProductsModal"
    :mask-closable="false" :closable="true" @on-visible-change="relatedProductsChange">
    <!--区域/国家-->
    <Card :bordered="false" dis-hover>
      <template #title>
        <span class="red-dot title_box">{{ regionTitle }}</span>
      </template>
      <template v-if="relatedProductsType === 'complianceResponsiblePerson'">
        <div>
          <span class="color-666">{{ $t('key1005593') }}</span>
          <span class="distributorThemeColor">{{ relatedProductsDetails.zoneName + ' ；' }}</span>
        </div>
      </template>
      <template v-else>
        <h3 class="color-666 mb10">{{ $t('key1005594') }}</h3>
        <div class="flex align-items-center">
          <span>{{ $t('key1005595') }}</span>
          <Tag color="#FD5425" v-for="(ele,idx) in regionList" :checkable="ele.checkable"
            :class="ele.disabled ? 'setCursor' : ''"
            :checked="ele.checked" @on-change="(checked) => selectRegion(checked, idx)">
            {{ ele.name }}
          </Tag>
        </div>
      </template>
    </Card>
    <!--商品选择-->
    <Card :bordered="false" dis-hover>
      <template #title>
        <span class="red-dot title_box">{{ $t('key1000685') }}</span>
      </template>
      <div class="mb15">
        <p class="color-666 mb5">{{ $t('key1005596') }}</p>
        <p class="distributorThemeColor">{{ $t('key1005597') }}</p>
      </div>
      <div class="flex flex-wrap align-items-center wid100P">
        <vueTreeSelect
          style="width:300px; margin-right: 20px;"
          v-model="pageParams.ymsProductCategoryId"
          :clearable="true"
          :searchable="true"
          :openOnFocus="true"
          :closeOnSelect="true"
          :noResultsText="$t('key1000102')"
          :noOptionsText="$t('key1000375')"
          :placeholder="$t('key1000369')"
          :normalizer="normalizer"
          :options="ymsProductCategoryList">
          <template #option-label="{ node, labelClassName }">
            <label
              :class="labelClassName"
              :title="node.label">
              {{ node.label }}
            </label>
          </template>
        </vueTreeSelect>
        <Input style="width:200px; margin-right: 20px;" v-model.trim="pageParams.cnName" :placeholder="$t('key1000380')"/>
        <Input style="width:200px; margin-right: 40px;" v-model.trim="pageParams.ymsSpus" :placeholder="$t('key1000714')"/>
        <Button class="mr12" type="primary" @click="search">{{ $t('key1000011') }}</Button>
        <Button @click="reset">{{ $t('key1000109') }}</Button>
      </div>
      <!--列表区域-->
      <div class="table-box mt14">
        <Table
          ref="tbableDom"
          highlight-row
          border
          max-height="450"
          :loading="tableLoading"
          :columns="tableColumns"
          :data="tableData"
          @on-selection-change="tableChange">
        </Table>
      </div>
      <!--分页区域-->
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        style="text-align: right; margin: 20px 0;"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </Card>
    <div class="drawer_footer">
      <Button class="mr15" type="primary" :disabled="selectTableData.length<=0" @click="relatedProductsBtn">{{ $t('key1000111') }}</Button>
      <Button @click="relatedProductsModal = false">{{ $t('key1000112') }}</Button>
    </div>
  </Drawer>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonSessionStorage, getCloudTreeData, isJSON} from "@/utils/common";
import vueTreeSelect from "@riophae/vue-treeselect";

export default {
  name: 'relatedProductsDrawer',
  mixins: [Mixin],
  props: {
    responsibleAreaList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      relatedProductsModal: false,
      relatedProductsType: null,
      relatedProductsDetails: {},
      pageParams: {
        ymsProductCategoryId: null,
        cnName: '',
        ymsSpus: '',
        pageNum: 1,
        pageSize: 15
      },
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 300,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let productName = '';
            if (name) {
              if (isJSON(name)) {
                let obj = JSON.parse(name);
                productName = obj[v.languagesVal];
              } else {
                productName = name;
              }
            }
            let imagePath = params.row.imagePath;
            let list = [
              v.tableImg(h, params, 'imagePath', imagePath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: productName,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695'),
          key: 'skuNumber',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'),
          renderHeader(h) {
            return h('div', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697')}(${v.currencyState})`);
          },
          key: 'suggestPrice',
          minWidth: 160,
          align: 'left',
          render(h, {row}) {
            const {maxSuggestPrice, minSuggestPrice} = row;
            let price = '0';
            if (maxSuggestPrice && minSuggestPrice) {
              price = maxSuggestPrice === minSuggestPrice
                ? maxSuggestPrice
                : `${minSuggestPrice} ~ ${maxSuggestPrice}`;
            } else {
              price = maxSuggestPrice || minSuggestPrice || '0';
            }
            return h('span', price);
          }
        }
      ],
      tableData: [],
      total: 0,
      ymsProductCategoryList: [],
      selectTableData: [],
      regionList: [],
    };
  },
  computed: {
    regionTitle() {
      return this.relatedProductsType === 'complianceResponsiblePerson' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005591') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005592');
    },
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initRelatedProductsDrawerData(type, details) {
      this.relatedProductsType = type;
      if (details) {
        switch (type) {
          case 'complianceResponsiblePerson':
            this.responsibleAreaList.map((item) => {
              if (item.zoneCode === details.zoneCode) {
                details.zoneName = item.name;
              }
            });
            break;
          case 'manufacturer':
            this.responsibleAreaList.map((item) => {
              this.regionList.push({
                ...item,
                checkable: true,
                checked: true,
                disabled: false
              });
            });
            break;
        }
        this.relatedProductsDetails = details;
      }
      let obj = commonSessionStorage.getItem('erpConfig');
      let ymsSiteId = obj ? obj.ymsSite ? obj.ymsSite.ymsSiteId : null : null;
      getCloudTreeData(api.post_ymsProductCategory_api_queryAll, null, null, ymsSiteId).then((data) => {
        this.ymsProductCategoryList = data;
      });
      this.search();
      this.relatedProductsModal = true;
    },
    // 搜索
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置筛选
    reset() {
      this.pageParams = {
        cnName: '',
        ymsProductCategoryId: null,
        ymsSpus: '',
        pageNum: 1,
        pageSize: 15
      };
    },
    // 获取商品数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.tableLoading = true;
      let obj = Object.assign({}, v.pageParams);
      let query = {
        ymsProductCategoryId: obj.ymsProductCategoryId,
        cnName: obj.cnName,
        ymsSpus: obj.ymsSpus ? [obj.ymsSpus] : [],
        shelveStatus: 1,
        orderBy: 'createdTime',
        distributorMerchantId: v.userInfo.merchantId,
        productTypes: ['1', '2', '3', '4', '5'],
        upDown: 'down',
        pageNum: obj.pageNum,
        pageSize: obj.pageSize
      };
      v.axios.post(api.post_ymsProductInfo_api_query, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let list = data.list || [];
          v.tableData = list;
          v.total = data.total;
          v.updateTableDom('tbableDom');
        } else {
          v.tableLoading = false;
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    },
    // 确定按钮
    relatedProductsBtn() {
      let list = [];
      let url = '';
      switch (this.relatedProductsType) {
        case 'complianceResponsiblePerson': {
          if (this.selectTableData.length) {
            list = this.selectTableData.map(item => ({
              ymsCompliancePersonId: this.relatedProductsDetails.ymsCompliancePersonId,
              ymsProductId: item.ymsProductId,
              zoneCode: this.relatedProductsDetails.zoneCode
            }));
            url = api.post_ymsCompliancePerson_insertCompliancePersonProducts;
          }
          break;
        }
        case 'manufacturer': {
          const zoneCodeList = this.regionList.filter(item => item.checked).map(item => item.zoneCode);
          if (this.selectTableData.length && zoneCodeList.length) {
            this.selectTableData.forEach(product => {
              zoneCodeList.forEach(zoneCode => {
                list.push({
                  ymsManufacturerInfoId: this.relatedProductsDetails.ymsManufacturerInfoId,
                  ymsProductId: product.ymsProductId,
                  zoneCode
                });
              });
            });
            url = api.post_ymsManufacturerInfo_insertManufacturerProduct;
          }
          break;
        }
      }

      if (url && list.length) {
        this.axios.post(url, list, {
          loading: true,
          loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
        }).then(res => {
          if (res.data.code === 0) {
            this.relatedProductsModal = false;
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000280'));
            this.$emit('updateData', true);
          }
        });
      }
    },
    // 选择区域、国家
    selectRegion(value, id) {
      this.regionList[id].checked = value;
      if (!value) {
        this.regionList.map((item, index) => {
          item.disabled = true;
          item.checkable = false;
          if (index === id) {
            item.checkable = true;
            item.disabled = false;
          }
        });
      } else {
        this.regionList.map((item) => {
          item.disabled = false;
          item.checkable = true;
        });
      }
      this.$forceUpdate();
    },
    // 监听弹窗
    relatedProductsChange(value) {
      if (!value) {
        this.reset();
        this.regionList = [];
        this.tableData = [];
        this.selectTableData = [];
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    vueTreeSelect
  },
};
</script>

<style lang="less" scoped>
.relatedProductsDrawer_box {
  /deep/ .ivu-drawer-body {
    padding: 0 20px;

    .ivu-card-head {
      padding: 14px 0;
    }

    .ivu-card-body {
      padding: 14px 0;
    }

    .title_box {
      color: #333;
      font-size: 15px;
      font-weight: bold;
      background-color: #fff;
    }

    .red-dot:before {
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 14px;
      color: #ed4014;
    }

    .ivu-tag {
      border-radius: 11px;
      cursor: pointer;
      margin: 0 12px 0 0;
      padding: 0 10px;
    }

    .ivu-tag.setCursor {
      cursor: not-allowed;
    }
  }

  .drawer_footer {
    width: 1000px;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #e8eaec;
    text-align: left;
    padding: 12px 0 12px 15px;
    background-color: #fff;
    z-index: 100;
  }
}
</style>
